import React from "react";
import { hydrateRoot, createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

const rootEl = document.getElementById("root");
const tree = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

if (rootEl.hasChildNodes()) {
  // Prerendered HTML present → hydrate
  hydrateRoot(rootEl, tree);
} else {
  // Fresh client-side render (admin routes, dev server, etc.)
  createRoot(rootEl).render(tree);
}
